import { UseControllerProps } from 'react-hook-form';
import dayjs, { Dayjs } from 'dayjs';
import { readMoney } from '../../utils/formatters';

type EventRules = { [key: string]: UseControllerProps['rules'] };

export const eventRules: EventRules = {
  dateRequired: {
    required: 'Data é obrigatória',
    validate: (value: Dayjs) => {
      return isNaN(value.toDate().getTime()) ? 'Data inválida' : true;
    },
  },
  dateMinNowRequired: {
    required: 'Data é obrigatória',
    validate: (value: Dayjs) => {
      return isNaN(value.toDate().getTime()) ||
        value.diff(dayjs().startOf('day')) < 0
        ? 'Data inválida'
        : true;
    },
  },
  dateOpcional: {
    validate: (value: Dayjs) => {
      if (value == null) {
        return true;
      }
      return isNaN(value.toDate().getTime()) ||
        value.diff(dayjs().startOf('day')) < 0
        ? 'Data inválida'
        : true;
    },
  },
  timeRequired: {
    required: 'Hora é obrigatória',
    validate: (value: Dayjs) =>
      isNaN(value.toDate().getTime()) ? 'Hora inválida' : true,
  },
  occurrenceRequired: {
    min: {
      message: 'Digite um número maior ou igual a um',
      value: 1,
    },
  },
  teacherRequired: {
    required: 'É necessário selecionar o professor',
  },
  studentRequired: {
    required: 'É necessário selecionar o aluno(a)',
  },
  placeTypeRequired: {
    required: 'É necessário selecionar o tipo de local da aula',
  },
  placeRequired: {
    required: 'É necessário escrever o local da aula',
    minLength: {
      message: 'É necessário escrever o local da aula',
      value: 1,
    },
  },
  levelRequired: {
    required: 'É necessário selecionar o nivel da aula',
  },
  descriptionRequired: {
    required: 'É necessário escrever uma descrição',
  },
  subjectRequired: {
    required: 'É necessário selecionar a matéria lecionada',
  },
  currencyValueRequired: {
    required: 'É necessário preencher o valor',
  },
  currencyValueGreaterThanZero: {
    required: 'É necessário preencher o valor',
    validate: (value: string) => {
      const money = readMoney(value);
      return money < 0.01 ? 'Valor deve ser no mínimo R$ 0,01' : true;
    },
  },
  intervalNumber: {
    required: 'É necessário preencher o intervalo',
    min: {
      message: 'Intervalo deve ser no mínimo 1',
      value: 1,
    },
  },
};
